import React from 'react'
import { Box } from 'components/ui'
import frame from './frame.svg'

export const Notifications = () => (
  <Box
    width="550px"
    height="365px"
    display="flex"
    justifyContent="center"
    position="relative"
    backgroundImage={`url(${frame})`}
    backgroundRepeat="no-repeat"
    backgroundSize="cover"
    backgroundPosition="0 -15px"
  ></Box>
)

export default Notifications
